import { PLACES, LBL, PTS, ptsTxt, bg } from "../lib/api";

export const Ballot = ({ entries, ballot, dirty, saving, onSave }) => {
  const any = PLACES.some((p) => ballot[p]);
  const label = saving ? "Guardando…" : dirty ? "Guardar votos" : any ? "Votos guardados ✓" : "Elige 3";
  return (
    <div className="ballot" data-testid="ballot-bar">
      <div className="wrap">
        <div className="slots">
          {PLACES.map((p) => {
            const e = entries.find((x) => x.id === ballot[p]);
            return (
              <div className="slot" key={p} data-testid={`ballot-slot-${p}`}>
                <div className="t" style={e ? bg(e.photoId) : {}}>{e ? <i>{LBL[p]}</i> : LBL[p]}</div>
                <div className="l"><b>{LBL[p]} lugar · {ptsTxt(PTS[p])}</b><span>{e ? e.name : "Elige"}</span></div>
              </div>
            );
          })}
        </div>
        <button className="btn" type="button" disabled={saving || !dirty} onClick={onSave} data-testid="save-vote-btn">{label}</button>
      </div>
    </div>
  );
};
